// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { packGuidelinesService } from './service';
import * as packGuidelinesActions from './actions';
import * as types from './actionTypes';

function* packGuidelinesSaga() {
  const res = yield call(packGuidelinesService);
  if (res.ok) {
    const result = res.body.items[0];
    const {
      title,
      description,
      main_image,
      gallery_image_picker,
    } = result;
    const mainImage = main_image.meta.download_url;
    const imagesWithDescription = gallery_image_picker.map((el) => {
      const image = el.image.meta.download_url;
      return {
        title: el.title,
        image: `${image}`,
        description: el.description.substring(3, el.description.length - 4),
      };
    });
    yield put(packGuidelinesActions.requestPageDataSuccess({
      title,
      description: description.substring(3, description.length - 4),
      mainImage: `${mainImage}`,
      imagesWithDescription,
    }));
  }
}

const packGuidelinesSagas = [
  takeEvery(types.PG_REQUEST_PAGE_DATA, packGuidelinesSaga),
];

export default packGuidelinesSagas;
